import React from 'react';

import Heading from '@/components/switchback/Heading/Heading';

import css from './GalleryHeader.module.css';

interface IGalleryHeader {
  title?: string;
}

const GalleryHeader: React.FC<IGalleryHeader> = ({ title = '' }) => (
  <div className={`${css.wrapper} gap-x-default md:grid-cols-main md:container-main`}>
    <div className={css.container}>
      <Heading className={css.title} level={1}>
        {title}
      </Heading>
    </div>
  </div>
);

export default GalleryHeader;
